import React from "react";
import { useDispatch } from "react-redux";

import { openDialog } from "../../store/actions";

interface IProps {
  slot: any;
  classes?: string;
  price: { gold: number; bricks: number, powerPoints?: number }
}

const DemolishBuildingButton = ({ slot, classes, price }: IProps) => {
  const dispatch = useDispatch();

  return (
    <a
      onClick={event => dispatch(openDialog({
        name: "DemolishBuilding",
        slot,
        price,
        event
      }))}
      className="dismiss"
    >
      <i className={`icon icon-zbourat grey ${classes || ""}`}/>
    </a>
  )
}

export default DemolishBuildingButton;
